import { Injectable } from '@angular/core';
import { PackagingService } from '@app/services/api/packaging.service';

import { Router } from '@angular/router';
import { FlashService } from '@app/services/flash.service';
import {
  AgrupatedPacks,
  AgrupatedPacksFail,
  AgrupatedPacksSuccess,
  ClearState,
  CreatePackaging,
  Delete,
  DeleteFail,
  DeleteImagePackaging,
  DeleteImagePackagingSuccess,
  DeleteSuccess,
  DownloadAllProviders,
  DownloadPackagingMaster,
  DownloadPackagingMasterFields,
  DuplicatePackaging,
  DuplicateWithCodes,
  DuplicateWithCodesFail,
  DuplicateWithCodesSuccess,
  ExportPackaging,
  ExportPackagingJobSuccess,
  ExportPackOrder,
  ExportPackOrderLoadSuccess,
  FetchAllMasterPackagings,
  FetchAllMasterPackagingsFail,
  FetchAllMasterPackagingsSuccess,
  GetPackagingCountries,
  GetPackagingCountriesFail,
  GetPackagingCountriesSuccess,
  GetPackagingMilestones,
  GetPackagingMilestonesFail,
  GetPackagingMilestonesSuccess,
  ImportFile,
  ImportFileFail,
  LoadPackaging,
  LoadPackagingById,
  LoadPackagingByIdSuccess,
  LoadPackagingFail,
  LoadPackagingSuccess,
  PackagingActionTypes,
  PackagingExportMassiveFail,
  PackagingExportMassiveFinish,
  PackagingExportMassiveSuccess,
  Update,
  UpdateFail,
  UpdateSuccess,
  UploadFile,
  UploadFileFail,
  UploadFileImg,
  UploadFileSuccess,
  UploadImgsPackagingFields,
  UploadImgsPackagingFieldsFail,
  UploadImgsPackagingFieldsSuccess,
  UploadProcessSuccess,
  UploadProcessUpdate,
  UploadProcessUpdateAccept,
} from '@core/actions/packaging.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators';


@Injectable()
export class PackagingEffects {
    @Effect()
    loadPackaging$: Observable<Action> = this.actions$.pipe(
        ofType<LoadPackaging>(PackagingActionTypes.LoadPackaging),
        switchMap(action => {
            return this.packagingApi.getPackaging().pipe(
                map((packaging: any) => {
                    return new LoadPackagingSuccess(packaging)
                }),
                catchError(error => of(new LoadPackagingFail(error)))
            )
        })
    );

    @Effect()
    loadPackagingById$: Observable<Action> = this.actions$.pipe(
        ofType<LoadPackagingById>(PackagingActionTypes.LoadPackagingById),
        switchMap(action => {
            return this.packagingApi.getPackaging(action.id, action.mode).pipe(
                map((packaging: any) => {
                    return new LoadPackagingByIdSuccess(packaging)
                }),
                catchError(error => of(new LoadPackagingFail(error)))
            )
        })
    );

    @Effect()
    createPackaging$: Observable<Action> = this.actions$.pipe(
        ofType<CreatePackaging>(PackagingActionTypes.CreatePackaging),
        switchMap(action => {
            return this.packagingApi.createPackaging(action.data).pipe(
                map((packaging: any) => {
                    this.router.navigate(['/packaging']);
                    this.fs.emit({
                        type: 'success',
                        message: 'Packaging creado correctamente'
                    });
                    return new LoadPackaging()
                }),
                catchError(error => of(new LoadPackagingFail(error)))
            )
        })
    );

    @Effect()
    update$: Observable<Action> = this.actions$.pipe(
        ofType<Update>(PackagingActionTypes.Update),
        map(action => [action.id, action.data, action.name]),
        concatMap(([id, data, name]) =>
            this.packagingApi.updatePackaging(id, data, name).pipe(
                map(packaging => {
                    this.router.navigate(['/packaging']);
                    return new UpdateSuccess(packaging.id, packaging);
                }),
                catchError(error => of(new UpdateFail(error)))
            )
        )
    );

    @Effect()
    uploadImgsPackagingFields$: Observable<Action> = this.actions$.pipe(
      ofType<UploadImgsPackagingFields>(PackagingActionTypes.UploadImgsPackagingFields),
      map(action => [action.packagingId, action.file, action.featured, action.followId]),
      concatMap(([packagingId, file, uploadType, followId]) =>
          this.packagingApi.uploadImgs(packagingId, file, uploadType,).pipe(
              map((packaging: any) => {
                  // this.router.navigate(['/packaging']);
                  return new UploadFileImg(packaging.signedUrl, file)
              }),
              catchError(error => of(new UpdateFail(error)))
          )
      )
  );

  @Effect()
  uploadFileImg$: Observable<Action> = this.actions$.pipe(
    ofType<UploadFileImg>(PackagingActionTypes.UploadFileImg),
    map(action => [ action.link, action.file]),
    switchMap(([link, file]) => {
      return this.packagingApi.uploadFile(link, file).pipe(
        map((record: any) => {
          return new UploadImgsPackagingFieldsSuccess();
        }),
        catchError(e => of(new UploadImgsPackagingFieldsFail()))
      );
    })
  );

  @Effect({dispatch: false})
  uploadImgsPackagingFieldsSuccess$ = this.actions$.pipe(
    ofType<UploadImgsPackagingFieldsSuccess>(PackagingActionTypes.UploadImgsPackagingFieldsSuccess),
    map((action) => {
        this.fs.emit({ type: 'success', message: 'Imagen subida correctamente' });
    })
  );

  @Effect({dispatch: false})
  uploadImgsPackagingFieldsFail$ = this.actions$.pipe(
    ofType<UploadImgsPackagingFieldsFail>(PackagingActionTypes.UploadImgsPackagingFieldsFail),
    map((action) => {
        this.fs.emit({ type: 'danger', message: 'No se pudo cargar la imagen' });
    })
  );

    @Effect()
    deleteManagementFollowPackaging$: Observable<Action> = this.actions$.pipe(
        ofType<Update>(PackagingActionTypes.DeleteManagementFollowPackaging),
        map(action => [action.id, action.data]),
        concatMap(([id, data]) =>
            this.packagingApi.updatePackaging(id, data).pipe(
                map(packaging => {
                return new UpdateSuccess(packaging.id, packaging);
                }),
                catchError(error => of(new UpdateFail(error)))
            )
        )
    );

    @Effect()
    addManagementPackaging$: Observable<Action> = this.actions$.pipe(
        ofType<Update>(PackagingActionTypes.AddManagementFollowPackaging),
        map(action => [action.id, action.data]),
        concatMap(([id, data]) =>
            this.packagingApi.updatePackaging(id, data).pipe(
                map(packaging => {
                return new UpdateSuccess(packaging.id, packaging);
                }),
                catchError(error => of(new UpdateFail(error)))
            )
        )
    );

  @Effect()
  updateSuccess$ = this.actions$.pipe(
    ofType<UpdateSuccess>(PackagingActionTypes.UpdateSuccess),
    map((action) => {
        this.fs.emit({ type: 'success', message: 'Packaging editado correctamente' });
        return new LoadPackaging()
    })
  );

  @Effect()
  exportPackOrderLoadSuccess$ = this.actions$.pipe(
    ofType<ExportPackOrderLoadSuccess>(PackagingActionTypes.ExportPackOrderLoadSuccess),
    map((action) => {
      this.fs.emit({ type: 'success', message: 'Orden actualizado correctamente' });
      return new LoadPackagingById(action.packId)
    })
  );

  @Effect()
  delete$: Observable<Action> = this.actions$.pipe(
    ofType<Delete>(PackagingActionTypes.Delete),
    map((action => [action.id, action.type])),
    concatMap(([id, type])=> {
        return this.packagingApi.deletePackaging(id).pipe(
            map((packaging: any) => {
                return new DeleteSuccess()
            }),
            catchError(error => of(new DeleteFail(error)))
        )
    })
  );

  @Effect({dispatch: false})
  deleteSuccess$ = this.actions$.pipe(
    ofType<DeleteSuccess>(PackagingActionTypes.DeleteSuccess),
    map((action) => {
        this.fs.emit({ type: 'success', message: 'Packaging eliminado correctamente' });
        this.router.navigate(['/packaging']);
        return new LoadPackaging()
    })
  );

  @Effect({ dispatch: false })
  downloadAllProviders = this.actions$.pipe(
    ofType<DownloadAllProviders>(PackagingActionTypes.DownloadAllProviders),
    map(action => [action.PackagingId]),
    tap(([PackagingId]) => {
      this.packagingApi.downloadAllProviders(PackagingId)
    })
  );

  @Effect({ dispatch: false })
  exportPackOrder$ = this.actions$.pipe(
    ofType<ExportPackOrder>(PackagingActionTypes.ExportPackOrder),
    map(action => [action.packId]),
    tap(([PackagingId]) => {
      this.packagingApi.exportOrder(PackagingId)
    })
  );

  @Effect({ dispatch: false })
  exportPackaging$ = this.actions$.pipe(
    ofType<ExportPackaging>(PackagingActionTypes.ExportPackaging),
    map(action => [
      action.id,
      action.role,
      action.followId,
      action.packagingId,
      action.typePack,
      action.downloabled,
      action.providerName,
      action.unitBusiness,
      action.country
    ]),
    tap(([id, role, followId, packagingId, typePack, downloabled, providerName, unitBusiness, country]) => {
      if (downloabled) {
        this.packagingApi.exportNewPackaging(id, role, followId, packagingId, typePack)
      } else {
        this.packagingApi.exportPackaging(id, role, followId, packagingId, typePack, providerName, unitBusiness, country)
      }
    })
  );

  @Effect({ dispatch: false })
  downloadPackagingMaster$ = this.actions$.pipe(
    ofType<DownloadPackagingMaster>(PackagingActionTypes.DownloadPackagingMaster),
    map(action => []),
    tap(() => {
      this.packagingApi.exportPackagingMaster()
    })
  );
  
  @Effect({ dispatch: false })
  downloadPackagingMasterFields$ = this.actions$.pipe(
    ofType<DownloadPackagingMasterFields>(PackagingActionTypes.DownloadPackagingMasterFields),
    map(action => []),
    tap(() => {
      this.packagingApi.exportPackagingMasterFields()
    })
  );

  @Effect()
  duplicatePackaging$ = this.actions$.pipe(
    ofType<DuplicatePackaging>(PackagingActionTypes.DuplicatePackaging),
    switchMap(action => {
      return this.packagingApi.duplicatePackaging(action.id).pipe(
          map((packaging: any) => {
              this.fs.emit({
                  type: 'success',
                  message: 'Packaging creado correctamente'
              });
              return new LoadPackaging()
          }),
          catchError(error => of(new LoadPackagingFail(error)))
      )
  })
  );


  @Effect()
  duplicateWithCodes$ = this.actions$.pipe(
    ofType<DuplicateWithCodes>(PackagingActionTypes.DuplicateWithCodes),
    switchMap(action => {
      return this.packagingApi.duplicateWithCodes(action.packId, action.objPackaging).pipe(
        concatMap((packaging: any) => {
          // this.fs.emit({
          //   type: 'success',
          //   message: 'Packaging migrado correctamente'
          // });
          return [new DuplicateWithCodesSuccess(packaging), new LoadPackaging()]
        }),
        catchError(error => of(new DuplicateWithCodesFail(error)))
      )
    })
  );

  @Effect({dispatch: false})
  duplicateWithCodesSuccess$ = this.actions$.pipe(
    ofType<DuplicateWithCodesSuccess>(PackagingActionTypes.DuplicateWithCodesSuccess),
    map((action) => {
      this.fs.emit({ type: 'success', message: "Packaging migrado correctamente" });
    })
  );

  @Effect({dispatch: false})
  duplicateWithCodesFail$ = this.actions$.pipe(
    ofType<DuplicateWithCodesFail>(PackagingActionTypes.DuplicateWithCodesFail),
    map((action) => {
      this.fs.emit({ type: 'danger', message: action.error.error.message });
    })
  );


  @Effect()
  importFile$: Observable<Action> = this.actions$.pipe(
    ofType<ImportFile>(PackagingActionTypes.ImportFile),
    map(action => [action.file, action.packaginId, action.typeMode, action.isSpecial]),
    switchMap(([file, packaginId, typeMode, isSpecial]) => {
      return this.packagingApi.getPackagingImportLink(file, packaginId, typeMode).pipe(
        map((record: any) => {
          return new UploadFile(record.signedUrl, record.id, file, typeMode, isSpecial);
        }),
        catchError(e => of(new ImportFileFail()))
      );
    })
  );

  @Effect()
  uploadFile$: Observable<Action> = this.actions$.pipe(
    ofType<UploadFile>(PackagingActionTypes.UploadFile),
    map(action => [action.uploadUrl, action.FileId, action.file, action.typeMode]),
    switchMap(([uploadUrl, FileId, file, typeMode]) => {
      return this.packagingApi.uploadFile(uploadUrl, file).pipe(
        map(record => {
          return new UploadFileSuccess(FileId, typeMode);
        }),
        catchError(e => of(new UploadFileFail(e)))
      );
    })
  );

  @Effect()
  agrupatedPacks$ = this.actions$.pipe(
    ofType<AgrupatedPacks>(PackagingActionTypes.AgrupatedPacks),
    map(action => [action.data]),
    switchMap(([data]) => {
      return this.packagingApi.agrupatedPacks(data).pipe(
        map(record => {
          return new AgrupatedPacksSuccess(record);
        }),
        catchError(e => of(new AgrupatedPacksFail(e)))
      );
    })
  );

  @Effect({dispatch: false})
  uploadFileSuccess$ = this.actions$.pipe(
    ofType<UploadFileSuccess>(PackagingActionTypes.UploadFileSuccess),
    map(action => [action.FileId, action.typeMode]),
    switchMap(([FileId, typeMode]) => {
      console.log("typeMode .>", typeMode)
      let auxTypeMode = ""
      if (typeMode === "providerType") {
        auxTypeMode = 'Packaging-Providers'
      } else if (typeMode === "packagingMassiveProviders") {
        auxTypeMode = 'packagingMassiveProviders'
      } else if (typeMode === "Packaging-pm-country") {
        auxTypeMode = "Packaging-pm-country"
      } else if (typeMode === "Packaging-designer") {
        auxTypeMode = "Packaging-designer"
      } else if (typeMode === "pm-final") {
        auxTypeMode = "Packaging-final"
      } else if (typeMode === "packaging-order") {
        auxTypeMode = "Packaging-order"
      } else if (typeMode === "packaging-master") {
        auxTypeMode = "Packaging-master"
      } else if (typeMode === "packaging-fields") {
        auxTypeMode = "Packaging-fields"
      } else {
        auxTypeMode = 'Packaging'
      }
      return this.packagingApi
        .notifyFileUpload(FileId, { processType: auxTypeMode })
        .pipe(
          map(record => {
            return new UploadProcessUpdate({
              status: 'pending',
              message: 'Procesando Packaging...'
            });
          }),
          catchError(e => of(new UploadFileFail(e)))
        );
    })
  );

    @Effect({dispatch: false})
    uploadProcessUpdateAccept$ = this.actions$.pipe(
    ofType<UploadProcessUpdateAccept>(PackagingActionTypes.UploadProcessUpdateAccept),
    map(action => [action.data]),
    switchMap(([data]) => {
      return this.packagingApi.updatePackagingFromFile(data).pipe(
        map(record => {
        }),
        catchError(e => of(new UploadFileFail(e)))
      );
    })
  );

  @Effect({dispatch: false})
  packagingExportMassiveSuccess$ = this.actions$.pipe(
    ofType<PackagingExportMassiveSuccess>(PackagingActionTypes.PackagingExportMassiveSuccess),
    map(action => this.packagingApi.finishExportMassiveProviders(action.data, action.followId)),
  );

  @Effect({dispatch: false})
  exportPackagingJobSuccess$ = this.actions$.pipe(
    ofType<ExportPackagingJobSuccess>(PackagingActionTypes.ExportPackagingJobSuccess),
    map(action => this.packagingApi.finishExportPackaging(action.data, action.name)),
  );
  
  @Effect({dispatch: false})
  packagingExportMassiveFinish$ = this.actions$.pipe(
    ofType<PackagingExportMassiveFinish>(PackagingActionTypes.PackagingExportMassiveFinish),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Descargado correctamente' });
    })
  );
  
  @Effect({dispatch: false})
  packagingExportMassiveFail$ = this.actions$.pipe(
    ofType<PackagingExportMassiveFail>(PackagingActionTypes.PackagingExportMassiveFail),
    map(action => {
      this.fs.emit({ type: 'danger', message: 'Error inesperado' });
    })
  );

  
  @Effect({dispatch: false})
  uploadProcessSuccess$ = this.actions$.pipe(
    ofType<UploadProcessSuccess>(PackagingActionTypes.UploadProcessSuccess),
    map((action) => {
        let message = 'Cargado con Exito'
        if(action.data && action.data.message){
          message = action.data.message
        }
        this.fs.emit({ type: 'success', message: message });
        return new ClearState()
    })
  );

  @Effect()
  fetchAllMasterPackagings$ = this.actions$.pipe(
    ofType<FetchAllMasterPackagings>(PackagingActionTypes.FetchAllMasterPackagings),
    switchMap(() => {
      return this.packagingApi.getPacksMaster().pipe(
        map((record: any) => {
          // console.log("record ->", record)
          return new FetchAllMasterPackagingsSuccess(record);
        }),
        catchError(error => of(new FetchAllMasterPackagingsFail(error)))
      )
    })
  );

  @Effect()
  getPackagingCountries$ = this.actions$.pipe(
    ofType<GetPackagingCountries>(PackagingActionTypes.GetPackagingCountries),
    map(action => [action.packId]),
    switchMap(([packId]) => {
      return this.packagingApi.getPacksCountries(packId).pipe(
        map((record: any) => {
          console.log("record ->", record)
          return new GetPackagingCountriesSuccess(record);
        }),
        catchError(error => of(new GetPackagingCountriesFail(error)))
      )
    })
  );
      
  @Effect({dispatch: false})
  uploadFileFail$ = this.actions$.pipe(
    ofType<UploadFileFail>(PackagingActionTypes.UploadFileFail),
    map((action) => {
      this.fs.emit({ type: 'danger', message: 'No se pudo cargar packaging' });
    })
    );
    

  @Effect()
  deleteImagePackaging$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteImagePackaging>(PackagingActionTypes.DeleteImagePackaging),
    map(action => [action.packId, action.data]),
    switchMap(([packId, data]) => {
      return this.packagingApi.deleteImgPack(packId, data).pipe(
        map(record => {
          return new DeleteImagePackagingSuccess();
        }),
        catchError(e => of(new UploadFileFail(e)))
      );
    })
  );
  @Effect()
  getPackagingMilestones$: Observable<Action> = this.actions$.pipe(
    ofType<GetPackagingMilestones>(PackagingActionTypes.GetPackagingMilestones),
    map(action => []),
    switchMap(() => {
      return this.packagingApi.getPackagingMilestones().pipe(
        map(record => {
          console.log("RECOOOOOOOORD ->", record)
          return new GetPackagingMilestonesSuccess(record);
        }),
        catchError(e => of(new GetPackagingMilestonesFail(e)))
      );
    })
  );

  @Effect({dispatch: false})
  deleteImagePackagingSuccess$ = this.actions$.pipe(
    ofType<DeleteImagePackagingSuccess>(PackagingActionTypes.DeleteImagePackagingSuccess),
    map((action) => {
        this.fs.emit({ type: 'success', message: 'Imagen eliminada' });
    })
  );

  constructor(
    private actions$: Actions,
    private packagingApi: PackagingService,
    private fs: FlashService,
    private router: Router
  ) {}
}
